/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import React from 'react';
import AppStatic from "@/utils/AppStatic";
import Image from 'next/image';
import whyWedsnap2 from "@/assets/images/wedsnap/why-wedsnap-2.webp";
import whyWedsnap1 from "@/assets/images/wedsnap/why-wedsnap-1.webp";
import whyWedsnap3 from "@/assets/images/wedsnap/why-wedsnap-3.webp";
import whyWedsnap4 from "@/assets/images/wedsnap/why-wedsnap-4.webp";
import whyWedsnap5 from "@/assets/images/wedsnap/why-wedsnap-5.webp";
import whyWedsnap6 from "@/assets/images/wedsnap/why-wedsnap-6.webp";
import whyWedsnap8 from "@/assets/images/wedsnap/why-wedsnap-8.webp";
import whyWedsnap9 from "@/assets/images/wedsnap/why-wedsnap-9.webp";
import whyWedsnap10 from "@/assets/images/wedsnap/why-wedsnap-10.webp";

const AppWedSnapFeatures = () => {
    return (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
            <div className="flex gap-0 items-center mb-8">
                <Image className="app-wedsnap-mini-image max-w-[90px] rounded-full"
                     src={whyWedsnap2}
                     alt="Weddify by Diaphan"
                     loading="lazy"/>
                <div className="w-full md:w-[60%] tracking-widest text-base uppercase p-2 ml-8 text-left">
                    {AppStatic.wedSnapWhyFirst.ro.translation}
                </div>
            </div>
            <div className="flex gap-0 items-center mb-8">
                <Image className="app-wedsnap-mini-image max-w-[90px] rounded-full"
                     src={whyWedsnap1}
                     alt="Weddify by Diaphan"
                     loading="lazy"/>
                <div className="w-full md:w-[60%] tracking-widest text-base uppercase p-2 ml-8 text-left">
                    {AppStatic.wedSnapWhySecond.ro.translation}
                </div>
            </div>
            <div className="flex gap-0 items-center mb-8">
                <Image className="app-wedsnap-mini-image max-w-[90px] rounded-full"
                     src={whyWedsnap3}
                     alt="Weddify by Diaphan"
                     loading="lazy"/>
                <div className="w-full md:w-[60%] tracking-widest text-base uppercase p-2 ml-8 text-left">
                    {AppStatic.wedSnapWhyThird.ro.translation}
                </div>
            </div>
            <div className="flex gap-0 items-center mb-8">
                <Image className="app-wedsnap-mini-image max-w-[90px] rounded-full"
                     src={whyWedsnap4}
                     alt="Weddify by Diaphan"
                     loading="lazy"/>
                <div className="w-full md:w-[60%] tracking-widest text-base uppercase p-2 ml-8 text-left">
                    {AppStatic.wedSnapWhyFourth.ro.translation}
                </div>
            </div>
            <div className="flex gap-0 items-center mb-8">
                <Image className="app-wedsnap-mini-image max-w-[90px] rounded-full"
                     src={whyWedsnap5}
                     alt="Weddify by Diaphan"
                     loading="lazy"/>
                <div className="w-full md:w-[60%] tracking-widest text-base uppercase p-2 ml-8 text-left">
                    {AppStatic.wedSnapWhyFifth.ro.translation}
                </div>
            </div>
            <div className="flex gap-0 items-center mb-8">
                <Image className="app-wedsnap-mini-image max-w-[90px] rounded-full"
                     src={whyWedsnap6}
                     alt="Weddify by Diaphan"
                     loading="lazy"/>
                <div className="w-full md:w-[60%] tracking-widest text-base uppercase p-2 ml-8 text-left">
                    {AppStatic.wedSnapWhySixth.ro.translation}
                </div>
            </div>
            <div className="flex gap-0 items-center mb-8">
                <Image className="app-wedsnap-mini-image max-w-[90px] rounded-full"
                     src={whyWedsnap8}
                     alt="Weddify by Diaphan"
                     loading="lazy"/>
                <div className="w-full md:w-[60%] tracking-widest text-base uppercase p-2 ml-8 text-left">
                    {AppStatic.wedSnapWhyEight.ro.translation}
                </div>
            </div>
            <div className="flex gap-0 items-center mb-8">
                <Image className="app-wedsnap-mini-image max-w-[90px] rounded-full"
                     src={whyWedsnap9}
                     alt="Weddify by Diaphan"
                     loading="lazy"/>
                <div className="w-full md:w-[60%] tracking-widest text-base uppercase p-2 ml-8 text-left">
                    {AppStatic.wedSnapWhyNine.ro.translation}
                </div>
            </div>
            <div className="flex gap-0 items-center mb-8">
                <Image className="app-wedsnap-mini-image max-w-[90px] rounded-full"
                     src={whyWedsnap10}
                     alt="Weddify by Diaphan"
                     loading="lazy"/>
                <div className="w-full md:w-[60%] tracking-widest text-base uppercase p-2 ml-8 text-left">
                    {AppStatic.wedSnapWhyTen.ro.translation}
                </div>
            </div>
        </div>
    );
}

export default AppWedSnapFeatures;
